var React = require('react');

function DragCircleInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.5","r":"291","transform":"matrix(1 0 0 -1 302 302)","stroke":"#2C4C77","strokeDasharray":"2 3","key":0}),React.createElement("circle",{"r":"4","transform":"matrix(1 0 0 -1 593 302)","fill":"#2C4C77","className":"circle-2","key":1}),React.createElement("circle",{"r":"4","transform":"matrix(1 0 0 -1 11 302)","fill":"#2C4C77","className":"circle-4","key":2}),React.createElement("circle",{"r":"4","transform":"matrix(1 0 0 -1 302 593)","fill":"#2C4C77","className":"circle-3","key":3}),React.createElement("circle",{"r":"4","transform":"matrix(1 0 0 -1 302 11)","fill":"#2C4C77","className":"circle-1","key":4})]);
}

DragCircleInline.defaultProps = {"viewBox":"0 0 604 604","fill":"none"};

module.exports = DragCircleInline;

DragCircleInline.default = DragCircleInline;
